// extracted by mini-css-extract-plugin
module.exports = {"container":"Partner_container__2YVYN","form":"Partner_form__3XHu6"};